import { AxiosService, ResponseService } from './';

const login = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/auth/login',
      isAuthorized: false,
      formData: _formData,
    };

    const response = await AxiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const forgotPassword = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/auth/password/forgot',
      isAuthorized: false,
      formData: _formData,
    };

    const response = await AxiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const resetPassword = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/auth/password/reset',
      isAuthorized: false,
      allowRequestCancellation: false,
      formData: _formData,
    };

    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const verifyToken = async (token) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/auth/verify_token/reset_password/' + token,
      isAuthorized: false,
    };

    const response = await AxiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const validatePassword = async (_formData) => {
  try {
    let _axiosData = {
      method: 'post',
      url: 'admin/auth/password/validate',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await AxiosService.hit(_axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const verifyTwoFA = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/auth/two_factor/verify',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await AxiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

export {
  login,
  forgotPassword,
  resetPassword,
  verifyToken,
  validatePassword,
  verifyTwoFA,
};
